import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { RestApiProvider } from '../../providers/rest-api/rest-api';
import { AuthProvider } from "../../providers/auth/auth";
import { OrarioPage } from '../../pages/orario/orario';

/**
 * Generated class for the AddorarioPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-addorario',
  templateUrl: 'addorario.html',
})
export class AddorarioPage {
  week = [
    {
      key: 2,
      value: 'Lunedì'
    },
    {
      key: 3,
      value: 'Martedì'
    },
    {
      key: 4,
      value: 'Mercoledì'
    },
    {
      key: 5,
      value: 'Giovedì'
    },
    {
      key: 6,
      value: 'Venerdì'
    },
    {
      key: 7,
      value: 'Sabato'
    },
    {
      key: 1,
      value: 'Domenica'
    },
  ];
  today;
  selDay;
  orari;
  aut;
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public rest: RestApiProvider,
    private readonly loadingCtrl: LoadingController,
    authProvider: AuthProvider,

  ) {
    this.orari = navParams.get('orari');
    this.aut = authProvider;

    this.today = new Date().toISOString();

  


  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AddorarioPage');
    console.log('week:'+JSON.stringify(this.week))
    console.log('orari:'+JSON.stringify(this.orari))


    var i;

    for (i = this.orari.length - 1; i >= 0; i -= 1) {
      console.log("loop:" + this.orari[i].giorno)
      var d = this.orari[i].giorno;
      this.week.splice(d-1, 1);

    }

  }

  aggiungiOraio(values: any) {

    let loading = this.loadingCtrl.create({

      spinner: 'bubbles',

      content: 'save categoria ...'

    });

    loading.present();


    console.log(values)

    console.log(JSON.stringify(values));


    let headers = this.aut.getHttpHeaders();

    this.rest.newGiornoConsegna(values);
    let hideFooterTimeout1 = setTimeout(() => {
      loading.dismiss();
      this.navCtrl.push(OrarioPage).then(() => { this.navCtrl.remove(this.navCtrl.getActive().index - 2, 2); });

    }, 2000);




  }
}



// WEBPACK FOOTER //
// ./src/pages/addorario/addorario.ts